import type { IProcessResource, WorkerPoolsSummaryResource, ProcessType } from "@octopusdeploy/octopus-server-client";
import { GetPrimaryPackageReference } from "@octopusdeploy/octopus-server-client";
import { isRunOnServerOrWorkerPool, loadAvailableWorkerPools, whereConfiguredToRun } from "~/areas/projects/components/Process/Common/CommonProcessHelpers";
import { ExecutionLocation } from "~/areas/projects/components/Process/types";
import type { ActionPlugin } from "~/components/Actions/pluginRegistry";
/**
 * Applies common logic to a producer process resource before saving.
 * This function corrects execution location properties and sets action names from packages if needed.
 * Used for Process Templates and Project Templates (producer resources).
 * @param process The process resource to modify
 * @param workerPoolsSummary The worker pools summary resource
 * @param getPluginForAction Function to get the plugin for an action by action ID
 * @param processType The type of process (ProcessTemplate or ProjectTemplate)
 */
export function applyCommonLogicToProducerProcessResource(process: IProcessResource, workerPoolsSummary: WorkerPoolsSummaryResource, getPluginForAction: (actionId: string) => ActionPlugin, processType: ProcessType.ProjectTemplate | ProcessType.ProcessTemplate): void {
    const availableWorkerPools = loadAvailableWorkerPools(workerPoolsSummary);
    process.Steps.forEach((step) => {
        step.Actions.forEach((action) => {
            const plugin = getPluginForAction(action.Id);
            const runOn = whereConfiguredToRun(!!step.Properties["Octopus.Action.TargetRoles"], action, availableWorkerPools, plugin, processType);
            if (runOn) {
                if (!isRunOnServerOrWorkerPool(runOn)) {
                    action.Container = { FeedId: null, Image: null, GitUrl: null, Dockerfile: null };
                }
                else {
                    if (runOn.executionLocation === ExecutionLocation.WorkerPool) {
                        step.Properties["Octopus.Action.TargetRoles"] = "";
                    }
                    if (runOn.executionLocation !== ExecutionLocation.WorkerPool && runOn.executionLocation !== ExecutionLocation.WorkerPoolForRoles) {
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        action.WorkerPoolId = null!;
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        action.WorkerPoolVariable = null!;
                    }
                    action.Container = runOn.container;
                }
            }
            if (!action.Name || action.Name.length === 0) {
                const primaryPackage = GetPrimaryPackageReference(action.Packages);
                if (primaryPackage) {
                    action.Name = primaryPackage.PackageId;
                }
            }
        });
    });
}
